import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { PurchaseStatisticsTotal } from "interface/purchaseStatistic";
import { formatNumber } from "utils/formatters";

interface PurchaseStatisticsTotalMobileListProps {
	items: PurchaseStatisticsTotal[];
	loading: boolean;
}

const PurchaseStatisticsTotalMobileList: FC<
	PurchaseStatisticsTotalMobileListProps
> = ({ items, loading }) => {
	const { t } = useTranslation();

	const empty = !loading && items.length === 0;

	return (
		<div className="purchase-statistic-list-mobile">
			{empty && (
				<div className="purchase-statistic-list-mobile-empty">
					{t("NoRows")}
				</div>
			)}

			<div className="purchase-statistic-list-card-body">
				{items.map((item, index) => (
					<div
						key={`${item.productCode}-${index}`}
						className="purchase-statistic-list-row purchase-statistic-list-card"
					>
						<div className="purchase-statistic-list-row-main">
							<div className="purchase-statistic-list-row-title">
								{item.buyerName || "-"}
							</div>
						</div>

						<div className="purchase-statistic-list-row-metrics">
							<div>
								<span>{t("Product")}</span>
								<strong>{item.product || "-"}</strong>
							</div>
						</div>

						<div className="purchase-statistic-list-row-metrics">
							<div>
								<span>{t("Weight")}</span>
								<strong>{formatNumber(item.totalNetWeightKg)} kg</strong>
							</div>
							<div>
								<span>{t("AveragePrice")}</span>
								<strong>{formatNumber(item.averagePrice)} kr</strong>
							</div>
							<div>
								<span>{t("Value")}</span>
								<strong>{formatNumber(item.totalAmount)} kr</strong>
							</div>
						</div>
					</div>
				))}
			</div>

			{loading && (
				<div className="purchase-statistic-list-mobile-loading">
					{t("Loading")}
				</div>
			)}
		</div>
	);
};

export default PurchaseStatisticsTotalMobileList;
